import React from 'react';
import intl from 'react-intl-universal';
import PackActions from '../actions/PackActions';
import StateStore from '../stores/StateStore';
import AuthStore from '../stores/AuthStore';

class VariantListItem extends React.Component {
  selectVariant(e) {
    PackActions.selectVariant(parseInt(e.target.getAttribute('data-code')))
  }

  render() {
    const { variant } = this.props
    return (
      <div onClick={this.selectVariant} data-code={variant.name} className="elem-tile">
        <h5>{variant.name}</h5>
        {variant.attrs}
      </div>
    );
  }
}

function getVariantListItem(variant) {
  return (
    <VariantListItem
      key={variant.id}
      variant={variant}
    />
  );
}

class VariantsComponent extends React.Component {

  constructor() {
    super();
    this.state = {
      variants: StateStore.getVariants(),
      config: AuthStore.getConfig()
    }
  }

  render() {
    let variantListItems;
    if (this.state.variants) {
      variantListItems = Object.keys(this.state.variants).map((key, index) => getVariantListItem({
         'id': index,
         'name': key,
         'attrs': this.state.variants[key]
      }))
    }
    return (
      <div>
        <h1>
          <div className="breadcrumb">
              <span>{intl.get('Znalezione warianty')}:</span>
          </div>
        </h1>
        <div className="elem-list">
          {variantListItems}
        </div>
      </div>
    );
  }
}

export default VariantsComponent;



// WEBPACK FOOTER //
// ./src/components/Variants.js